import { SUBSCRIPTION_STATUS } from '../constants';

export const isPaidMerchant = ({ currentMerchant }) =>
  [SUBSCRIPTION_STATUS.ACTIVE, SUBSCRIPTION_STATUS.NON_RENEWING].includes(
    currentMerchant?.subscriptionStatus
  ) || !currentMerchant?.trialEndsOn;
